import React from 'react';
import StepEnum from '../../Enums/StepEnum';
import { updateProductListingOnRackSelect, updateProductDetailOnRackSelect, setCookieData } from '../../Hooks/hooks';
import { onRackSelectorClose } from '../../Utils/Tracking';

const RackSelectorOption = ({
  name,
  description,
  icon,
  filterclassNames,
  filterInformation,
  handleProductSelect,
  index,
  selectionText,
}) => {
  let fitStatus = '';

  const handleRackSelect = async () => {
    if (window.location.href.indexOf('-_-') === -1) {
      fitStatus = updateProductListingOnRackSelect(fitStatus, filterclassNames);
    } else {
      fitStatus = updateProductDetailOnRackSelect(fitStatus, filterInformation);
    }
    handleProductSelect(name, fitStatus, filterInformation?.AdapterName);

    setCookieData({
      fitStatus: fitStatus,
      name: name,
      step: StepEnum.RackSelect,
      index: index,
      adapter: filterInformation?.AdapterName,
    });

    onRackSelectorClose(name);
  };

  return (
    <div
      className={`bar-item ${name === selectionText ? 'active' : ''}`}
      onClick={() => {
        handleRackSelect(name, fitStatus);
      }}
    >
      <div className="icon-container">
        <i className={icon}></i>
      </div>
      <div className="bar-item-text">
        <h5 className="heading5">{name}</h5>
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
      </div>
    </div>
  );
};

export default RackSelectorOption;
